import React from 'react';
import { Dialog, DialogContent, DialogTitle, Switch, FormControlLabel, FormGroup } from '@material-ui/core';
function SettingsControls(props) {
    const [state, setState] = React.useState({
        darkMode: window.dark_theme,
        secondThing: false
    });
    const { setDarkTheme } = props;
    const handleSwitchChange = name => event => {
        if (name === 'darkMode') {
            console.log('Setting dark mode: ' + event.target.checked);
            window.dark_theme = event.target.checked;
            setDarkTheme(event.target.checked);
        }
        setState({ ...state, [name]: event.target.checked });
    };
    return (React.createElement(FormGroup, null,
        React.createElement(FormControlLabel, { control: React.createElement(Switch, { checked: state.darkMode, onChange: handleSwitchChange('darkMode'), value: 'darkmode' }), label: 'Use dark theme' })));
}
function SettingsDialog(props) {
    const { open, handleClose, setDarkTheme } = props;
    return (React.createElement(Dialog, { open: open, onClose: handleClose },
        React.createElement(DialogTitle, { id: 'settings-dialog-title' }, "Settings"),
        React.createElement(DialogContent, null,
            React.createElement(SettingsControls, { setDarkTheme: setDarkTheme }))));
}
export default SettingsDialog;
//# sourceMappingURL=SettingsDialog.js.map